var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCentiliLogoNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.833.833v40C34.053 38.108 40 30.186 40 20.833s-5.948-17.274-14.167-20M.833 12.5c7.359-.663 13.686-4.024 15-12.5C9.025 1.451 3.44 6.202.833 12.5M0 19.943c0 8.99 5.598 16.604 13.333 19.224V18.333H.067c-.04.532-.067 1.068-.067 1.61",
    transform: "translate(-20 -20) translate(20 20)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCentiliLogoNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/centiliLogoNew.0f39227b.svg";
export { ForwardRef as ReactComponent };